export default __webpack_public_path__ + "static/media/quick_quote_icon.c7b83f3a.svg";